import { Clipboard } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { LANG_DICTIONARY_TOKEN } from '@constants/diConstant';
import { FuiButtonComponent, FuiDialog, FuiDialogComponent, FuiTextInputComponent } from '@fui/fui-components';
import { ITableDataRow } from '../../profiler.interface';

@Component({
    selector: 'app-details-dialog',
    templateUrl: './details-dialog.component.html',
    imports: [CommonModule, ReactiveFormsModule, FuiButtonComponent, FuiTextInputComponent, FuiDialogComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class DetailsDialogComponent extends FuiDialog<ITableDataRow, void> {
    private readonly clipboard = inject(Clipboard);
    readonly dictionary = inject(LANG_DICTIONARY_TOKEN);

    @HostBinding('class') classes = 'block w-[70vw] h-[80vh]';

    onCopy() {
        this.clipboard.copy(this.data.sql);
        this.onClose();
    }
}
